import {Action} from '@ngrx/store';
import {Deserialize, Serialize} from 'cerialize';
import { DeleteChatsAction } from '../actions/chats/delete-chats-action';
import { DeleteChatsErrorAction } from '../actions/chats/delete-chats-error-action';
import { GetChatsAction } from '../actions/chats/get-chats-action';
import { GetChatsErrorAction } from '../actions/chats/get-chats-error-action';
import { GetChatsSuccessAction } from '../actions/chats/get-chats-success-action';
import { ChatsState } from '../states/chats-state';

const initialState = new ChatsState();

export function ChatsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: ChatsState = Deserialize(serializedState, ChatsState);

  switch (action.type) {
    case GetChatsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetChatsSuccessAction.type:
      state.ready = true;
      state.chats = (<GetChatsSuccessAction>action).chats;
      state.error = null;
      break;

    case GetChatsErrorAction.type:
      state.ready = true;
      state.error = (<GetChatsErrorAction>action).error;
      break;

    case DeleteChatsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case DeleteChatsErrorAction.type:
      state.ready = true;
      state.error = (<DeleteChatsErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
